import _ from 'lodash';
import { makeInvokeBackendFunction } from '@skyjs/client-context';
import RequestContextService from './RequestContextService.js';

export default async function getRequestContext() {
  const url = new URL(location.href);

  let authTokenExpirationDate;
  let refreshToken;
  let isPendingMFA;
  let signInMethod;

  const domainName = location.hostname;

  let code;

  if (url.searchParams.has('code') && url.searchParams.size === 1) {
    code = url.searchParams.get('code');
    url.searchParams.delete('code');
  }

  let authToken = url.searchParams.get('auth-token');
  url.searchParams.delete('auth-token');

  window.history.replaceState(window.history.state, '', url.href);

  if (code) {
    // Deprecated : Login is handled user-land now using the login route instead of here
    const res = await register(code, domainName);

    if (res) {
      authToken = res.authToken;
      authTokenExpirationDate = res.authTokenExpirationDate;
      refreshToken = res.refreshToken;
      isPendingMFA = res.isPendingMFA;
      signInMethod = res.signInMethod;
    }

    if (!authToken) {
      RequestContextService.clear();
    }
  } else if (!authToken) {
    const req = RequestContextService.get();

    if (req !== null) {
      req.domainName = window.location.hostname;
      return req;
    }
  }

  const req = _.omitBy(
    { domainName, authToken, authTokenExpirationDate, refreshToken, isPendingMFA, signInMethod },
    _.isNil
  );

  if (authToken != null || authTokenExpirationDate != null) {
    RequestContextService.update(req);
  }

  return req;
}

const register = async (code, domainName) => {
  try {
    const invokeFunction = makeInvokeBackendFunction({ domainName });
    const res = await invokeFunction('authentication-register-from-code', { code }, 'POST');

    return res.data;
  } catch (err) {
    const status = _.get(err, 'response.status');
    if (status === 403) return undefined;
    throw err;
  }
};
